import { Suspense } from 'react';
import AppRoutes from './Routes';
import * as Tooltip from '@radix-ui/react-tooltip';
import * as Toast from '@radix-ui/react-toast';
import { ThemeProvider } from './components/context/ThemeContext';
import { SnackbarProvider } from './components/context/SnackbarContext';
import store from './store/store';
import { Provider } from 'react-redux';
import Loading from './components/common/Loading';
import ChunkErrorBoundary from './components/common/ChunkErrorBoundary';
import { Box } from '@mui/system';
function App() {

  const AppLoader = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'black'
        }}
      >
        <Loading />
      </Box>
    );
  };

  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<AppLoader />}>
        <ThemeProvider>
          <SnackbarProvider>
            <Provider store={store}>
              <Tooltip.Provider>
                <Toast.Provider swipeDirection="right">
                  <AppRoutes />
                </Toast.Provider>
              </Tooltip.Provider>
            </Provider>
          </SnackbarProvider>
        </ThemeProvider>
      </Suspense>
    </ChunkErrorBoundary>
  );
}

export default App;
